import React, { FC } from "react";

const style: React.CSSProperties = {
    height: "auto",
    verticalAlign: "middle",
    width: 20
};

const ActionsOnGoogleIcon: FC = () => {
    return <img style={style} src="/img/actions-on-google-logo.svg" alt="GCP Actions on Google" />;
};

export { ActionsOnGoogleIcon };
